import React, { useState } from "react";
import FormInput from "../../../components/common/FormInput/FormInput";
import "../auth.css";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import {useNavigate } from "react-router-dom";
import { login } from "../../../api/auth/auth";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const isDisabled = !email || !password;

  const LoginAuth = async (e) => {
    e.preventDefault();
    if (isDisabled) return;

    try {
      setLoading(true);
      const res = await login({ email, password });
      localStorage.setItem("access_token", res.access_token);
      navigate("/menu");
    } catch (error) {
      alert("Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <form className="form-conatiner" onSubmit={LoginAuth}>
        <img src="/Images/magnus-logo.png" alt="logo" />

        <Row>
          <Col xs={12}>
            <label className="form-label">Email</label>
            <FormInput
              type="email"
              placeholder="Enter email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Col>

          <Col xs={12}>
            <label className="form-label">Password</label>
            <FormInput
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Col>

          <Col xs={12}>
            <button
              type="submit"
              className="login-btn"
              disabled={isDisabled || loading}
            >
              {loading ? "Logging in..." : "Login"}
            </button>
          </Col>
        </Row>
      </form>
    </div>
  );
};

export default Login;
